import { useMediaQuery, useTheme } from '@mui/material';

/**
 * Renvoie `true` lorsque l'écran est de taille téléphone (< 600px, breakpoint
 * `sm` de MUI).
 *
 * Sert à brancher un rendu mobile dédié sans toucher au rendu desktop :
 *
 *   const isMobile = useIsMobile();
 *   return isMobile ? <VueMobile /> : <VueDesktop />; // VueDesktop = code actuel
 *
 * Sur desktop/tablette (>= 600px) le hook renvoie `false`, donc le chemin
 * existant est rendu à l'identique — aucune régression possible.
 */
export default function useIsMobile(): boolean {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('sm'));
}
